import React from 'react'
import { Container } from 'reactstrap'
import styled from 'styled-components'
import { Section } from '../../GlobalStyles'

export const Heading = styled.div`
  font-weight: 400;
  line-height: 1.2;
  margin-bottom: 20px;
  font-size: 20px;
  color: ${p => p.color || p.theme.colors.darkGray};
  @media screen and (min-width: 1025px) {
    font-size: 36px;
    margin-bottom: 36px;
  }
`

export const OverviewSection = () => {
  return (
    <Section>
      <Container>
        <Heading>
          The PGA of America is pleased that you’ll be a part of PGA.com Coach
          Profiles. This dynamic platform will help run your business and grow
          your brand while reaching millions who want to improve their games.
        </Heading>
      </Container>
    </Section>
  )
}

export default OverviewSection
